import { render, staticRenderFns } from "./s-tpl-form.vue?vue&type=template&id=4df63432&scoped=true"
import script from "./s-tpl-form.vue?vue&type=script&lang=js"
export * from "./s-tpl-form.vue?vue&type=script&lang=js"
import style0 from "./s-tpl-form.vue?vue&type=style&index=0&id=4df63432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df63432",
  null
  
)

export default component.exports